export function trimCharacter(input: string, characterToRemove: string) {
    return trimCharacterRight(trimCharacterLeft(input, characterToRemove), characterToRemove)
}

export function trimCharacterLeft(input: string, characterToRemove: string): string {
    while (input.charAt(0) === characterToRemove) {
        input = input.substring(1)
    }
    return input
}

export function trimCharacterRight(input: string, characterToRemove: string): string {
    while (input.charAt(input.length - 1) === characterToRemove) {
        input = input.substring(0, input.length - 1)
    }
    return input
}
